import React from "react";
import { ContentText } from "../../global-types/AdvisoryContent";

type HeadlineProps = {
  text: ContentText;
};

const Headline = React.forwardRef<HTMLHeadingElement, HeadlineProps>(
  ({ text }, ref) => {
    return (
      <h3 ref={ref} className={`if typography ${text.classNames}`}>
        {text.value}
        {text.child && (
          <span className={`if tag ${text.child.classNames}`}>
            {text.child.value}
          </span>
        )}
      </h3>
    );
  }
);

export default Headline;
